export const QUANTITY_OBSERVATION_INPUT_ELEMENT =
  "quantity-observation-input-element";
export const QUANTITY_COMPONENTS_OBSERVATION_INPUT_ELEMENT =
  "quantity-components-observation-input-element";
export const DATE_TIME_OBSERVATION_INPUT_ELEMENT =
  "date-time-observation-input-element";
export const CONCEPT_OBSERVATION_INPUT_ELEMENT =
  "concept-observation-input-element";
